<template>
  <div class="card">
    <loading
      :active.sync="this.reportLoadingOld"
      :can-cancel="true"
      :is-full-page="true"
    >
    </loading>

    <div class="card-body">
      <h5 class="card-title text-muted">
        <strong> {{ $t("customer.selectReport") }}</strong>
      </h5>
      <hr />
      <button
        class="btn btn-warning btn-sm text-center"
        @click="changeCustomer()"
      >
        {{ $t("buttons.changeCustomer") }}
      </button>
      <div class="h3" v-show="true">
        {{ this.companyName }}
      </div>
      <search :term="searchTerm" @search="setSearchTerm" />
      <div v-if="!visibleReportsTable" class="col">
        <h6 class="float-right">
          {{ $t("customer.counter") }} {{ processedCustomersTotal }}
        </h6>
        <div class="form-group container-fluid p-0">
          <div class="col-md-12 p-0">
            <div class="row">
              <div class="col-md-3 p-0">
                <label for="materialGroup">
                  {{ $t("common.selectMaterialGroup") }}
                </label>
                <select
                  id="materialGroup"
                  class="form-control"
                  :value="materialGroup"
                  @click="setChangeMaterialGroup"
                >
                  <option
                    v-for="(material, index) in materialGroupList"
                    :key="index"
                    :value="material.value"
                  >
                    {{ material.name }}
                  </option>
                </select>
              </div>
              <div class="col-md-3">
                <label for="selectCharacteristics">
                  {{ $t("common.selectCharacteristics") }}
                </label>
                <select
                  id="characteristics"
                  class="form-control"
                  :value="characteristics"
                  @click="setChangeCharacteristics"
                >
                  <option
                    v-for="(state, index) in characteristicsList"
                    :key="index"
                    :value="state.value"
                  >
                    {{ state.name }}
                  </option>
                </select>
              </div>
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-3">
                    <label for="selectDateFromAccounting">
                      {{ $t("common.selectDateFromAccounting") }}
                    </label>
                    <input
                      id="dateFromAccounting"
                      type="date"
                      :value="dateFromAccounting"
                      name="dateFromAccounting"
                      class="form-control"
                      @change="setChangeDateFromAccounting($event.target.value)"
                    />
                  </div>
                  <div class="col-md-3">
                    <label for="selectDateToAccounting">
                      {{ $t("common.selectDateToAccounting") }}
                    </label>
                    <input
                      id="dateToAccounting"
                      type="date"
                      :value="dateToAccounting"
                      name="dateToAccounting"
                      class="form-control"
                      @change="setChangeDateToAccounting($event.target.value)"
                    />
                  </div>
                  <div class="col-md-3 center d-flex">
                    <button
                      class="btn btn-success btn-sm text-center"
                      @click="filterSalesAnalysisReport('salesAnalysisReport')"
                    >
                      {{ $t("buttons.generateReportSalesAnalysis") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-show="visibleReportsTable" class="table-responsive">
        <table class="table table-bordered table-striped p-2">
          <thead>
            <tr>
              <th scope="col">
                {{ $t("customer.codeBp") }}
              </th>
              <th scope="col">
                {{ $t("customer.name") }}
              </th>
              <th scope="col">
                {{ $t("customer.vatNumber") }}
              </th>
              <th scope="col">
                {{ $t("customer.billingAddress") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="customer in processedCustomers"
              :key="customer['customerId']"
              class="m-1 p-1"
              :class="{ 'bg-warning': false }"
            >
              <td class="text-center">
                <h6>{{ customer.cardCode }}</h6>
              </td>
              <td class="text-center">
                <h6>{{ customer.company }}</h6>
              </td>
              <td>{{ customer.vat }}</td>
              <td>
                {{ customer.addressInformation }}
              </td>
              <td colspan="3" class="">
                <button
                  class="btn btn-success btn-sm text-center"
                  @click="handleSelectCustomer(customer)"
                >
                  {{ $t("buttons.select") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <page-controls
          :number-of-pages="customerPageCount"
          :current-page="currentPage"
          @pageChange="setCurrentPage"
          @sizeChange="setPageSize"
        />
      </div>

      <div v-show="!visibleReportsTable" class="table-responsive">
        <table class="table table-bordered table-striped p-2">
          <thead>
            <tr>
              <th scope="col">
                {{ $t("products.itemCode") }}
              </th>
              <th scope="col">
                {{ $t("products.description") }}
              </th>
              <th scope="col">
                {{ $t("products.quantity") }}
              </th>
              <th scope="col">
                {{ $t("products.summaryAmount") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="report in processedReports"
              :key="report['customerId']"
              class="m-1 p-1"
              :class="{ 'bg-warning': false }"
            >
              <td class="text-center">
                <h6>{{ report.message }}</h6>
              </td>
              <td class="text-center">
                <h6>{{ report.status }}</h6>
              </td>
              <td>{{ parseFloat(report.vat) }}</td>
              <td>
                <!-- {{ getPrice(report) }} -->
                {{ currencyDisplay(getPrice(report), false) }}
              </td>
              <td colspan="3" class="">
                <button
                  class="btn btn-success btn-sm text-center"
                  @click="
                    handleShowDetails('salesAnalysisReportDetails', report)
                  "
                >
                  {{ $t("buttons.showDetails") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <page-controls
          :number-of-pages="reportsPageCount"
          :current-page="currentPageReports"
          @pageChange="setCurrentPageReports"
          @sizeChange="setPageSizeReports"
        />
        <div class="sales-report-details">
          <sales-report-details-modal
            :visible="isSalesModalVisible"
            :productsDetails="this.reportsDetail"
            @on-close="isSalesModalVisible = !isSalesModalVisible"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";
import Search from "./Search";
import PageControls from "./PageControls";
import { Characteristics, MaterialGroup } from "../enums/ReportDictionary";
import i18n from "../translations";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import SalesReportDetailsModal from "./SalesReportDetailsModal.vue";
import { currencyMixin } from "../mixins";

export default {
  name: "Reports",
  mixins: [currencyMixin],
  components: { Search, PageControls, Loading, SalesReportDetailsModal },
  filters: {
    currency(value) {
      return new Intl.NumberFormat("pl-PL", {
        style: "currency",
        currency: "PLN",
      }).format(value);
    },
  },
  data() {
    return {
      locale: i18n.locale,
      characteristicsList: Characteristics,
      materialGroupList: MaterialGroup,
      isLoading: false,
      fullPage: true,
      isSalesModalVisible: false,
      // dateFromAccounting: "",
      // dateToAccounting: "",
      visibleReportsTable: false,
      reportLoadingOld: false,
    };
  },

  mounted() {
    // this.setChangeDateToAccounting = new Date().toISOString().slice(0, 10);
    // this.setChangeDateFromAccounting = new Date(
    //   new Date().setDate(new Date().getDate() - 30)
    // )
    //   .toISOString()
    //   .slice(0, 10);
    this.setCustomer("");
    this.visibleReportsTable = true;
    this.$store.commit("reports/setReports", []);
    this.$store.commit("reports/setReportsDetails", []);
    this.$store.commit("reports/setReportsTotal", 0);
    // this.setChangeCharacteristics("0");
    // this.setChangeMaterialGroup("0");
  },
  computed: {
    ...mapGetters("customers", [
      "processedCustomers",
      "processedCustomersTotal",
      "customersFilteredBySalesPerson",
      "customersFilterByProvince",
      "customerPageCount",
      "customerLoading",
    ]),
    ...mapState("customers", [
      "searchTerm",
      "currentPage",
      "searchDateFrom",
      "searchDateTo",
      "searchCharacteristics",
      "searchMaterialGroup",
    ]),
    ...mapGetters("reports", [
      "reportLoading",
      "reportsPageCount",
      "processedReports",
      "processedReportsTotal",
      "materialGroup",
      "charecteristics",
      "customer",
      "companyName",
      "dateFromAccounting",
      "dateToAccounting",
      "reports",
      "reportsDetail",
    ]),
    ...mapState("reports", [
      "materialGroup",
      "characteristics",
      "reportLoading",
      "currentPageReports",
      "reportLoading",
    ]),
    ...mapState("auth", ["user"]),
  },
  methods: {
    ...mapActions("reports", ["getReports", "getReportsDetails"]),
    ...mapMutations("customers", [
      "setSearchTerm",
      "setSearchProvince",
      "setSearchCountry",
      "setCurrentPage",
      "setPageSize",
      "setCurrentProvince",
      "setCurrentCountry",
      "setSlpCode",
    ]),
    ...mapMutations("reports", [
      "setSearchCharacteristics",
      "setSearchMaterialGroup",
      "setSlpCode",
      "setCustomer",
      "setCurrentPageReports",
      "setPageSizeReports",
      "setDateFromAccounting",
      "setDateToAccounting",
    ]),
    getPrice(product) {
      debugger;
      switch (product.currency) {
        case "EUR":
          return product.dayAfter ;//parseFloat(product.dayAfter) + " " + product.currency;
          break;
        case "USD":
          return product.docEntry;//parseFloat(product.docEntry) + " " + product.currency;
          break;
        case "PLN":
          return product.gross;//parseFloat(product.gross) + " " + product.currency;
          break;
        default:
        // code block
      }
    },
    setCurrentUser() {
      let slpCode = this.user.slpCode;
      this.setSlpCode(slpCode);
      this.processedCustomers;
    },
    setChangeCharacteristics: function(event) {
      this.setSearchCharacteristics(event.target.value);
    },
    setChangeMaterialGroup: function(event) {
      this.setSearchMaterialGroup(event.target.value);
    },
    setChangeDateFromAccounting(value) {
      this.setDateFromAccounting(value);
    },
    setChangeDateToAccounting(value) {
      this.setDateToAccounting(value);
    },
    handleSelectCustomer(customer) {
      this.setCustomer(customer);
      this.$store.commit("cart/setCleanCart", []);
      this.visibleReportsTable = false;
    },
    changeCustomer() {
      this.visibleReportsTable = !this.visibleReportsTable;
    },
    async handleShowDetails(type, data) {
      this.isSalesModalVisible = true;
      this.getReportsDetails({ type: type, itemCode: data.message });
    },
    async filterSalesAnalysisReport(type, itemCode = null) {
      debugger;
      this.getReports(type, itemCode);
    },
  },
};
</script>
